export const getPlainObject = (obj: any) => {
  delete obj['init'];
  delete obj['toJSON'];
  return obj;
};

export const getModelArray = (list: any[], Type: any) => {
  if (!list) {
    return [];
  }

  return list.map((li) => {
    const itemDto = new Type();
    return { init: itemDto.init, toJSON: itemDto.toJSON, ...li };
  });
};

export const getModelObject = (item: any, Type: any) => {
  const itemDto = new Type();
  if (!item) {
    return null;
  }
  return { toJSON: itemDto.toJSON, init: itemDto.init, ...item };
};

export const getDtoFromPlainObject = <T>(
  plainObj: any,
  dtoType: new (plainObj: T) => T,
): T => {
  const obj = new dtoType({ ...plainObj });
  return obj;
};

export const getPlainArray = <T>(array: Array<T>): Array<T> =>
  array.map((item) => getPlainObject(item));

export const getDtoArrayFromPlainArray = <T>(
  plainArr: any[],
  dtoType: new (plainObj: T) => T,
): T[] => {
  const dtoArr = plainArr.map((plainObj) => getDtoFromPlainObject<T>(plainObj, dtoType));
  return dtoArr;
};

export const getPlainDto = (data) => {
  if (typeof data !== 'object' || data === null || data instanceof Date) {
    if (data instanceof Date) {
      if (data.toISOString() === new Date(null).toISOString()) {
        return null;
      }
    }
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => getPlainDto(item));
  }

  const obj = {};
  Object.keys(data).forEach((key) => {
    if (typeof data[key] === 'function') {
      return;
    }
    const val = getPlainDto(data[key]);
    if (val !== undefined) {
      obj[key] = val;
    }
  });
  return obj;
};
